export default [
  {
    path: '/home.html',
    name: 'home',
    component: () => import('@/views/Home/Home.vue'),
    meta: {
      layout: 'full',
    },
  },
]
